export const objectKeys=Object.keys;export const objectEntries=Object.entries;